"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var react_1 = __importStar(require("react"));
var styles_1 = require("@material-ui/core/styles");
var slate_1 = require("slate");
var slate_react_1 = require("slate-react");
var react_image_crop_1 = __importDefault(require("react-image-crop"));
var core_1 = require("@21st-night/core");
var CropRounded_1 = __importDefault(require("@material-ui/icons/CropRounded"));
var CloseRounded_1 = __importDefault(require("@material-ui/icons/CloseRounded"));
var core_2 = require("@material-ui/core");
var LightboxImage_1 = __importDefault(require("../../../LightboxImage"));
var ActionButtons_1 = __importDefault(require("../../../ActionButtons"));
var IconButton_1 = __importDefault(require("../../../IconButton"));
var Button_1 = __importDefault(require("../../../Button"));
require("react-image-crop/dist/ReactCrop.css");
exports.useStyles = styles_1.makeStyles(function (theme) {
    return styles_1.createStyles({
        root: {
            position: 'relative',
            marginBottom: theme.spacing(2),
            textAlign: 'center',
            '&:hover $toolbar': {
                display: 'block',
            },
        },
        cropper: {
            maxHeight: 300,
        },
        imageWrapper: {
            width: '100%',
            position: 'relative',
        },
        imageInner: {
            position: 'absolute',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
        },
        image: {
            width: '100%',
            position: 'absolute',
            top: 0,
            left: 0,
            bottom: 0,
        },
        toolbar: {
            position: 'absolute',
            top: 0,
            right: 0,
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            borderBottomLeftRadius: 8,
            display: 'none',
        },
    });
});
var EditorUploadedImage = function (_a) {
    var attributes = _a.attributes, children = _a.children, id = _a.id, croppedProp = _a.cropped, _b = _a.crop, cropProp = _b === void 0 ? {
        width: 50,
        height: 50,
        x: 25,
        y: 25,
    } : _b, _c = _a.dimensions, dimensions = _c === void 0 ? { height: 0, width: 0 } : _c, element = _a.element;
    var classes = exports.useStyles();
    var editor = slate_react_1.useEditor();
    var _d = __read(react_1.useState(false), 2), cropMode = _d[0], setCropMode = _d[1];
    var _e = __read(react_1.useState(croppedProp), 2), cropped = _e[0], setCropped = _e[1];
    var _f = __read(react_1.useState(false), 2), lightbox = _f[0], setLightbox = _f[1];
    var _g = __read(react_1.useState(cropProp), 2), crop = _g[0], setCrop = _g[1];
    var _h = __read(react_1.useState(new Image()), 1), image = _h[0];
    var path = slate_react_1.ReactEditor.findPath(editor, element);
    var selected = slate_react_1.useSelected();
    var src = process.env.REACT_APP_IMGIX_URL + "/" + id + "?w=1200";
    react_1.useEffect(function () {
        image.src = src;
    }, [image.src, src]);
    image.onload = function () {
        if (dimensions.height === 0) {
            slate_1.Transforms.setNodes(editor, {
                dimensions: {
                    height: image.height,
                    width: image.width,
                    aspectRatio: core_1.calculateAspectRatio(image),
                },
            });
        }
    };
    if (cropped && !cropMode) {
        var cropXPercent = (crop.x || 0) / 100;
        var cropYPercent = (crop.y || 0) / 100;
        var cropWidthPercent = (crop.width || 100) / 100;
        var cropHeightPercent = (crop.height || 100) / 100;
        var x = Math.round(cropXPercent * dimensions.width);
        var y = Math.round(cropYPercent * dimensions.height);
        var width = Math.round(dimensions.width * cropWidthPercent);
        var height = Math.round(dimensions.height * cropHeightPercent);
        src += "&rect=" + x + "," + y + "," + width + "," + height;
    }
    function enableCrop() {
        setCropMode(true);
        if (crop.width === 0 || crop.height === 0) {
            setCrop({
                width: 50,
                height: 50,
                x: 25,
                y: 25,
            });
        }
    }
    function handleRemove() {
        slate_1.Transforms.setNodes(editor, { type: 'paragraph', children: [{ text: '' }] }, { at: path });
    }
    function saveCrop() {
        var isCropped = crop.width !== 0 && crop.height !== 0;
        setCropMode(false);
        setCropped(isCropped);
        slate_1.Transforms.setNodes(editor, {
            cropped: isCropped,
            crop: __assign(__assign({}, crop), { x: Math.round(crop.x || 0), y: Math.round(crop.y || 0) }),
        }, { at: path });
    }
    return (react_1.default.createElement("div", __assign({ className: classes.root }, attributes),
        react_1.default.createElement("div", { contentEditable: false, style: {
                position: 'relative',
                backgroundColor: '#ECEFF1',
                paddingTop: cropMode
                    ? 0
                    : core_1.calculateAspectRatio(dimensions, crop, true) + "%",
            } },
            cropMode && (react_1.default.createElement(react_image_crop_1.default, { imageStyle: { maxWidth: '100%' }, src: src, crop: __assign(__assign({}, crop), { unit: '%' }), onChange: function (newCrop, _a) {
                    var x = _a.x, y = _a.y, height = _a.height, width = _a.width;
                    return setCrop({
                        x: x,
                        y: y,
                        height: height,
                        width: width,
                    });
                } })),
            !cropMode && (react_1.default.createElement(LightboxImage_1.default, { disableHint: true, maxHeight: "auto", src: src, alt: "", className: classes.image })),
            react_1.default.createElement(ActionButtons_1.default, { spaced: true, align: "end", className: classes.toolbar },
                !cropMode && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(core_2.Tooltip, { title: "Crop image", placement: "top" },
                        react_1.default.createElement(IconButton_1.default, { onClick: enableCrop },
                            react_1.default.createElement(CropRounded_1.default, null))),
                    react_1.default.createElement(core_2.Tooltip, { title: "Remove image", placement: "top" },
                        react_1.default.createElement(IconButton_1.default, { onClick: handleRemove },
                            react_1.default.createElement(CloseRounded_1.default, null))))),
                cropMode && (react_1.default.createElement(Button_1.default, { variant: "text", size: "small", color: "secondary", onClick: saveCrop }, "Save")))),
        react_1.default.createElement("div", null, children),
        selected && (react_1.default.createElement("div", { contentEditable: false, style: {
                boxShadow: 'inset 0px 0px 0px 2px rgba(3,169,244,1)',
                userSelect: 'none',
                pointerEvents: 'none',
                position: 'absolute',
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
            } }))));
};
exports.default = EditorUploadedImage;
//# sourceMappingURL=EditorUploadedImage.js.map